/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ["admin", "editor"];
  return valid_map.indexOf(str.trim()) >= 0;
}

/**
 * 校验手机号格式
 */
export function validMobile(phone) {
  return /^1[3-9]\d{9}$/.test(phone);
}

// +------------------------------------------------------
// | 表单验证 - 自定义验证规则
// +------------------------------------------------------

/**
 * 验证手机号格式
 */
export function formValidMobile(rule, value, callback) {
  if (value === "") {
    callback(new Error("请输入手机号"));
  } else {
    if (!validMobile(value)) {
      callback(new Error("手机号格式错误"));
    }
    callback();
  }
}

/**
 * 验证年龄格式
 */
export function formValidAge(rule, value, callback) {
  if (value === "") {
    callback(new Error("请输入年龄"));
  } else {
    if (Number(value) > 200) {
      callback(new Error("年龄不能大于200"));
    }
    callback();
  }
}
